import React from 'react';

import { Button } from 'ui';
import InputText from 'ui/atoms/InputText/InputText';
import FormField from 'ui/molecules/FormField/FormField';

const ResetForm = () => {
  // deprecated

  return (
    <div className="login-form">
      <div className="login-form__item">
        <h3 className="login-form__title">Reset Password</h3>
      </div>
      <div className="login-form__item">
        <FormField label="Password">
          <InputText type="password" placeholder={t('auth:Password')} />
        </FormField>
      </div>
      <div className="login-form__item">
        <FormField label="Repeat Password">
          <InputText type="password" placeholder={t('auth:Password')} />
        </FormField>
      </div>
      <div className="login-form__item">
        <Button text="Reset Password" isFullWidth />
      </div>
    </div>
  );
};

export default ResetForm;
